<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.ref"
          :label="$t('contract.ref')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('contract.start') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.start_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.start_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('contract.end') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.end_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.end_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="contracttypeSelectItems"
          v-model="item.type"
          :items="contracttypeSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('contract.type')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="customerSelectItems"
          v-model="item.customer"
          :items="customerSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('contract.customer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import InputDate from '../InputDate';

export default {
  name: 'ContractFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  components: {
    InputDate
  },
  data() {
    return {};
  },
  mounted() {
    this.customerGetSelectItems();
    this.contracttypeGetSelectItems();
  },

  computed: {
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
    }),
    ...mapFields('contracttype', {
      contracttypeSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems',
      contracttypeGetSelectItems: 'contracttype/fetchSelectItems',
    }),
  }
};
</script>
